<template>
    <div class="LogoImgTheme">
        <div v-for="(item, index) in ThemeList" :key="index">
            <div class="round_Outside">
                <div :class="(Temp_Value == item.Id ? 'clickRound' : 'NoclickRound') + ' round'"
                    @click="changeRound(item.Id)">
                    <img style="height: 39px; width: 39px;" :src="cdnURL + 'CompanyInfo_Theme_' + item.Text + '.png'" />
                    <div v-if="item.IsPrime" class="PrimeBanna">
                        {{ $t("lbl_EMPBE_CompanyInfo_Prime") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: ["value", ""],
    inject: ["permissionData"],
    data() {
        return {
            ThemeList:
                [
                    {
                        Id: 1,
                        Text: "Purple",
                        IsPrime: false
                    },
                    {
                        Id: 2,
                        Text: "Yellow",
                        IsPrime: false
                    },
                    {
                        Id: 3,
                        Text: "Blue",
                        IsPrime: false
                    },
                    {
                        Id: 4,
                        Text: "Green",
                        IsPrime: false
                    },
                    {
                        Id: 5,
                        Text: "Grey",
                        IsPrime: false
                    }

                ],
            cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/Images/CompanyInfo/",
            Temp_Value: this.value
        }
    },
    watch: {
        value() {
            this.Temp_Value = this.value ?? 1;
            if (this.value === undefined) {
                this.$emit('input', this.Temp_Value);
            }
        },
        Temp_Value() {
            this.$emit('input', this.Temp_Value);
        }
    },
    computed: {

        APlusBooth() {
            if (this.permissionData) {
                return ["A+"].includes(this.permissionData["Type"]);
            } else {
                return false;
            }
        },

    },
    mounted() {
        if (this.APlusBooth)
            this.ThemeList.unshift
                (
                    { Id: 6, Text: "golden", IsPrime: true }
                );
    },
    methods: {
        changeRound(index) {
            this.Temp_Value = index;
        }

    }

}
</script>
<style lang="scss" scoped>
.LogoImgTheme {
    .round_Outside {
        float: left;
        padding: 10px;
    }

    .round {
        border-radius: 50%;
        position: relative;
    }

    .clickRound {
        border: 2px solid #7366FF;
    }

    .NoclickRound {
        border: 2px solid #ffffff;

    }

    .PrimeBanna {
        color: rgba(0, 0, 0, 0.80);
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        word-wrap: break-word;
        padding: 2px 4px;
        right: -20px;
        top: -10px;
        position: absolute;
        background: #FFD02C;
        border-radius: 25px;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
        display: inline-flex
    }
}
</style>